/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Statsupcomingplans2Inputs */

const en_statsupcomingplans2 = /** @type {(inputs: Statsupcomingplans2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upcoming`)
};

const de_statsupcomingplans2 = /** @type {(inputs: Statsupcomingplans2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anstehend`)
};

/**
* | output |
* | --- |
* | "Upcoming" |
*
* @param {Statsupcomingplans2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const statsupcomingplans2 = /** @type {((inputs?: Statsupcomingplans2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Statsupcomingplans2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_statsupcomingplans2(inputs)
	return de_statsupcomingplans2(inputs)
});
export { statsupcomingplans2 as "statsUpcomingPlans" }